// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '알리코제약',
  targetSheetName: '% 순',
  headerRowIndex: 6,
  headerRowCount: 1,
  dataStartRowIndex: 7,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '품목',
    price: '보험약가',
    commissionRate: '현행',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No',
    '약가 유지 여부',
    '제조구분',
    '품목',
    '보험코드',
    '성분',
    '대조약',
    '보험약가',
    '현행',
    '추가 정책',
    '비고',
  ],
});
